import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    }
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('x-device-access-token');
    if (token) {
        config.headers['Authorization'] = token;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;

export const notifier = axios.create({
    baseURL: process.env.REACT_APP_NOTIFIER_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    }
});

notifier.interceptors.request.use((config) => {
    const token = localStorage.getItem('x-device-access-token');
    if (token) {
        config.headers['Authorization'] = token;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
